import httpClient from ".";
import type {
  IBaseProviderSearchPayload,
  IFreeTextProviderSearchSuggestionByCategoryPayload,
  IFreeTextProviderSearchSuggestionPayload,
  IProviderSearchPayload,
} from "@/types";
import { API_ENDPOINTS } from "./endpoints";
import { PROVIDER_SEARCH_INITIATING_SOURCE } from "@/constants";

export const fetchProviderSearchSetting = async (
  settingPayload: IBaseProviderSearchPayload,
) => {
  const url = API_ENDPOINTS.PROVIDER_SEARCH.SETTINGS;
  const { token, ...payload } = settingPayload;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
    },
  };
  return httpClient
    .post(url, payload, config)
    .then((response) => response.data);
};

export const fetchFreeTextProviderSearchSuggestion = async (
  searchSuggestionPayload: IFreeTextProviderSearchSuggestionPayload,
) => {
  const url = API_ENDPOINTS.PROVIDER_SEARCH.FREETEXT_SEARCH;
  const { token, ...payload } = searchSuggestionPayload;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
    },
  };
  return httpClient
    .post(url, payload, config)
    .then((response) => response.data);
};

export const fetchFreeTextProviderSearchSuggestionByCategory = async (
  searchSuggestionByCategoryPayload: IFreeTextProviderSearchSuggestionByCategoryPayload,
) => {
  const url = API_ENDPOINTS.PROVIDER_SEARCH.FREETEXT_SEARCH_VIEW_MORE;
  const { token, ...payload } = searchSuggestionByCategoryPayload;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
    },
  };
  return httpClient
    .post(url, payload, config)
    .then((response) => response.data);
};

export const fetchProviderSearchResult = async (
  providerSearchPayload: IProviderSearchPayload,
  isFromWidget?: boolean,
) => {
  const url = API_ENDPOINTS.PROVIDER_SEARCH.SEARCH;
  const { token, ...payload } = providerSearchPayload;

  const editedPayload = {
    ...payload,
    source: isFromWidget
      ? PROVIDER_SEARCH_INITIATING_SOURCE.WIDGET
      : PROVIDER_SEARCH_INITIATING_SOURCE.SCREEN,
  };

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
    },
  };
  return httpClient
    .post(url, editedPayload, config)
    .then((response) => response.data);
};
